import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from 'shells/icon/svg/close-icon';
import {Link} from 'shells/link/link';

import {Setting} from '../../core/setting';

import styles from './marketing-upsell-banner.module.css';

export function MarketingUpsellBanner() {
    return (
        <Setting settingName='hide_marketing_upsell_banner'>
            {/* @ts-expect-error */}
            {({setting, updateSetting}) => {
                if (setting && !setting.value) {
                    return (
                        <div className={styles['message-container']}>
                            <div className={styles.message}>
                                <div className={styles.icon}>
                                    <AiSparkleNewIcon size={24} />
                                </div>
                                <div className={styles['message-text']}>
                                    Pro tip: Messages with over 50 recipients reach more inboxes
                                    when sent with{' '}
                                    <Link
                                        // @ts-expect-error
                                        as={RoutedLink}
                                        variant='primary'
                                        size='small'
                                        to='/email-marketing/summary'
                                    >
                                        Email marketing
                                    </Link>
                                </div>
                            </div>
                            <button
                                type='button'
                                onClick={() => updateSetting('1')}
                                className={styles['button-close']}
                            >
                                <CloseIcon size={14} />
                            </button>
                        </div>
                    );
                }

                return null;
            }}
        </Setting>
    );
}
